import React from "react";
import { Box } from "@mui/material";

export const CardLayout = ({ sx = {}, children }) => {
  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        margin: "22px",
        padding: "22px",
        borderRadius: "10px",
        border: "1px solid #f0f0f0",
        transition: "all linear 0.3s",
        WebkitTransition: "all linear 0.3s",
        MozTransition: "all linear 0.3s",
        msTransition: "all linear 0.3s",
        OTransition: "all linear 0.3s",
        ...sx,
        "&:hover": {
          WebkitBoxShadow: "0px 15px 25px 0px rgba(var(--blackRGB), 6%)",
          boxShadow: "0px 15px 25px 0px rgba(var(--blackRGB), 6%)",
        },
      }}
    >
      {children}
    </Box>
  );
};
